// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2fcWF","errors":"Errors_errors__25hQs"};